import React from 'react';
import '../style/Components.css';

const FooterComp = () => {
	return (
		<div className="footer">
			<center>&copy; bugged-codes.</center>
		</div>
	);
};

export default FooterComp;
